module.exports = __webpack_public_path__ + "img/guide_device_use_help.191c32a1.png";